// extracted by mini-css-extract-plugin
module.exports = {"LoadingSpinner":"payment-validation_LoadingSpinner__8mJ32","Wrapper":"payment-validation_Wrapper__jhao0"};